import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Briefcase, Cpu, Brain } from "lucide-react";

const items = [
  { icon: GraduationCap, title: "Study Smarter", text: "Learn practical methods that improve academic performance." },
  { icon: Briefcase, title: "Career Ready", text: "Develop the skills employers increasingly value." },
  { icon: Cpu, title: "Master AI", text: "Use artificial intelligence as a tool instead of becoming dependent on it." },
  { icon: Brain, title: "Think Clearly", text: "Build stronger judgement and better decision-making in an information-rich world." },
];

export default function WhyRead() {
  return (
    <section className="py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl mb-16">
          <span className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">The Difference</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4">Why Read Kate Mercer</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-7">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="group relative rounded-3xl p-8 bg-white border border-gray-100 overflow-hidden gold-glow"
                data-testid={`why-read-${i}`}
              >
                <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-gold/10 group-hover:bg-gold/25 blur-sm transition-colors duration-500" />
                <div className="relative">
                  <span className="inline-grid place-items-center h-14 w-14 rounded-2xl bg-[#0A0A0A] text-gold mb-6 group-hover:scale-110 transition-transform duration-500">
                    <Icon size={26} />
                  </span>
                  <h3 className="font-display text-xl font-bold mb-2">{it.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{it.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
